export enum SIDE_BAR_POSITION {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
}

export type TSideBarPosition = `${SIDE_BAR_POSITION}`;
